class UchPdpAutoPopulate {
    constructor(options) {
        let searchParams = new URLSearchParams(window.location.search);
        let path = location.pathname.split("/").filter(part=>part!='')
        console.error(path)
        this.holsterHandle = path.pop()
        console.error(this.holsterHandle)
        this.make = null;
        this.model = null;
        this.firearmHandle = null
        this.params = {};
        this.options = location.hash.replace("#","").split("/").map(part=>decodeURI(part));
        options = {}
        if (this.options.includes("for")) {
            this.options.shift()
            this.firearmHandle = this.options.shift()
        }
        document.addEventListener("ywm:selector:ready",event=>{
            console.error(this.firearmByHandle)
            if (this.firearmHandle) {
                this.selectedHolster = window.firearmsDB.holsterByHandle(this.holsterHandle);

                if (this.firearmHandle) {
                    let weapon = window.firearmsDB.firearmByHandle(this.firearmHandle);
                    this.selectWeapon(weapon);
                }
            }
        });
    }
    selectOptions() {
        let optionsMap = {};

        document.querySelectorAll(`[data-variant-input]`).forEach(
            option=>{
                if (option.tagName=="SELECT") {
                    for (const selectOption of option.options) {
                        optionsMap[selectOption.value.toLowerCase()]=selectOption;
                    }
                } else {
                    optionsMap[option.value.toLowerCase()]=option;
                }
            }
        )
        for (const option of this.options) {
            if (option!=null){
                let optionElement = optionsMap[option.toLowerCase()];
                if (optionElement) {
                    if (optionElement.tagName=="OPTION") {
                        let select = optionElement.parentNode;
                        optionElement.click();
                        select.value=option;
                        select.dispatchEvent(
                            new Event('change', { bubbles: true })
                        );
                    } else {
                        optionsMap[option.toLowerCase()].click();
                        optionsMap[option.toLowerCase()].dispatchEvent(
                            new Event('click', { bubbles: true })
                        );
                    }
                    

                    
                    
                }
            }
        }
    }
    selectWeapon(weapon) {
        this.selectOptions()        
        if (weapon) {
            document.dispatchEvent(
                new CustomEvent(
                    "ywm:autoselect:success",
                    {
                        bubbles:true,
                        detail:weapon
                    }
                )
            )
            
        }
    }
}

class VariantDrivenPdpAutoSelect extends  UchPdpAutoPopulate {
    constructor(options) {
        super(options)
        console.error(this.holsterHandle)
        document.addEventListener("ywm:database:loaded",event=>{
            if (this.holsterHandle) {
                this.selectedHolster = window.firearmsDB.holsterByHandle(this.holsterHandle);

                if (this.firearmHandle) {
                    let weapon = window.firearmsDB.firearmByHandle(this.firearmHandle);
                    this.selectWeapon(weapon);
                }
            }
        })

    }
    selectWeapon(weapon) {
        let selectedVariantSet = window.firearmsDB.compatibleVariantSets(weapon).find(set=>set.product==this.selectedHolster.id);
        
        if (selectedVariantSet) {
            this.options.unshift(selectedVariantSet.holsterSelectionLabel);
            this.selectOptions()
            document.querySelector(".compatibility-indicator").textContent=`✓ VERIFIED fit for ${weapon.fullName}`;
        }

    }
}